import React, { Component } from "react";
import { NavLink } from "react-router-dom";

import Table from "../../common/components/Table";
import Button from "../../../ui/button/Button";
import { formatDate } from "../../../utils/date-utils";
import { Localize } from "../../../locale/localization";
import { sortTableAndHead } from "../../../utils/content-utils";
import TableHeader from "../../common/components/TableHeader";
import filter from "lodash/filter";

class ContentListContainer extends Component {
  state = {
    sortedData: [],
    tableHead: [
      { name: "createdAt", uiName: Localize("date") },
      { name: "category", uiName: Localize("category") },
      { name: "name", uiName: Localize("header") },
      { name: "channel", uiName: Localize("channel") }
    ]
  };

  componentWillMount() {
    this.updateSortData(this.props.contents);
  }

  componentWillReceiveProps(nextProps) {
    this.updateSortData(nextProps.contents);
  }

  updateSortData = content => {
    this.setState(
      Object.assign({}, this.state, {
        sortedData: content ? content : []
      })
    );
  };

  sortTable = headItem => {
    const sorted = sortTableAndHead(
      headItem,
      this.state.tableHead,
      this.state.sortedData
    );

    this.setState(
      Object.assign({}, this.state, {
        sortedData: sorted.data,
        tableHead: sorted.head
      })
    );
  };

  renderContentRow = content => {
    const { type } = this.props;
    const { _id, createdAt, category, name, channel } = content;

    return (
      <tr key={_id}>
        <td>{formatDate(createdAt)}</td>
        {type !== "rules" && <td>{category}</td>}
        <td>{name}</td>
        {type !== "news" && <td>{channel}</td>}
        <td>
          <NavLink to={`/admin/${type}/edit/${_id}`}>
            {Localize("action.edit")}
          </NavLink>
        </td>
      </tr>
    );
  };

  renderTableHeader = () => {
    const { type } = this.props;
    let items = this.state.tableHead;

    if (type === "rules") {
      items = filter(items, function(item) {
        return item.name !== "category";
      });
    }

    if (type === "news") {
      items = filter(items, function(item) {
        return item.name !== "channel";
      });
    }

    return (
      <TableHeader
        items={items}
        onSort={this.sortTable}
        sortable={this.state.sortedData.length > 1}
      />
    );
  };

  render() {
    const { type } = this.props;
    const contents = this.state.sortedData;
    return (
      <div>
        {contents && contents.length > 0 ? (
          <Table
            items={contents}
            renderHeader={this.renderTableHeader}
            renderItem={this.renderContentRow}
          />
        ) : (
          <p>{Localize(`${type}.empty`)}</p>
        )}
        <footer>
          <NavLink to={`/admin/${type}/add`}>
            <Button icon="#plus" theme="text">
              {Localize(`${type}.add`)}
            </Button>
          </NavLink>
        </footer>
      </div>
    );
  }
}

export default ContentListContainer;



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentListContainer.js